module.exports = __webpack_public_path__ + "static/media/whatsapp-gray.be90a0e4.svg";